import { LazyModule, LazyImport } from 'owa-bundling';
import {
    EXPERIMENTS_ASSET_REGISTRY,
    preLoadCalendarBoardAssetExperiments,
} from 'owa-calendar-board-assets-experiments';
import { isFeatureEnabled } from 'owa-feature-flags';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarBoardAssets" */ './lazyIndex')
);

const ASSET_REGISTRY = new LazyImport(lazyModule, m => m.ASSET_REGISTRY);
const getNumInitialMenuItems = new LazyImport(lazyModule, m => m.getNumInitialMenuItems);

export function preLoadCalendarBoardAssets() {
    if (shouldLoadAssetExperiments()) {
        preLoadCalendarBoardAssetExperiments();
    } else {
        lazyModule.import();
    }
}

export function getCalendarBoardAssetRegistry() {
    if (shouldLoadAssetExperiments()) {
        return EXPERIMENTS_ASSET_REGISTRY.tryImportForRender();
    } else {
        return ASSET_REGISTRY.tryImportForRender();
    }
}

function shouldLoadAssetExperiments() {
    return isFeatureEnabled('cal-board-dev-loadAssetExperiments');
}

export function getNumInitialMenuItemsToShow() {
    return getNumInitialMenuItems.tryImportForRender()?.() ?? 0;
}
